module.exports = __webpack_public_path__ + "static/media/Gps-Off.357a7649.svg";